export enum Products {
	jira = 'JIRA',
	confluence = 'CONFLUENCE',
	other = 'OTHER',
}
